import { render, staticRenderFns } from "./OrderIntergral2.vue?vue&type=template&id=3b7191a6&scoped=true&"
import script from "./OrderIntergral2.vue?vue&type=script&lang=js&"
export * from "./OrderIntergral2.vue?vue&type=script&lang=js&"
import style0 from "./OrderIntergral2.vue?vue&type=style&index=0&id=3b7191a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7191a6",
  null
  
)

export default component.exports